import { render } from "./TraineeImportSuccessful.vue?vue&type=template&id=0cdd486e&scoped=true"
import script from "./TraineeImportSuccessful.vue?vue&type=script&lang=js"
export * from "./TraineeImportSuccessful.vue?vue&type=script&lang=js"

import "./TraineeImportSuccessful.vue?vue&type=style&index=0&id=0cdd486e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cdd486e"]])

export default __exports__